export class AbortError extends Error {
  constructor(message?: unknown) {
    super(`The operation was aborted: ${getErrorMessage(message)}`);
    this.name = 'AbortError';
  }
}
function getErrorMessage(input: unknown): string {
  if (input instanceof Error) {
    return input.message;
  }

  if (!input) {
    return 'Unknown error';
  }

  return String(input);
}
